import { Button, useTheme } from "@mui/material";

const ButtonComponent = ({
    label,
    onClick,
    loading=false,
    variant="contained",
    sx,
    ...other
}) => {
    const theme = useTheme();


    return (
        <>
            <Button
                variant={variant}
                onClick={onClick}
                disableElevation
                sx={{
                    textTransform: 'none',
                    '&: hover': {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText
                    },
                    borderRadius: 16,
                    fontSize: {xs: 12, md: 14, lg: 16},
                    ...sx
                }}
                className="onPointer"
                loading={loading}
                {...other}
            >
                {label}
            </Button>
        </>
    );
}

export default ButtonComponent;